// VRT size-guide modal. Lazily fetches the real Size Guide page on first
// open, parses out its <vrt-tabs class="vrt-sizeguide"> table (from
// sections/vrt-size-guide-table.liquid) and mounts it — same fetch-and-swap
// convention as vrt-related-products.js, but fetching the whole page rather
// than a scoped section_id (see the comment in vrt-size-guide-modal.liquid
// for why). `<vrt-tabs>` inside the fetched fragment self-upgrades once
// mounted, since vrt-tabs.js is already loaded on the page.

class VrtSizeguideModal extends HTMLElement {
  connectedCallback() {
    this._overlay = this.querySelector('[data-sgm-overlay]');
    this._status = this.querySelector('[data-sgm-status]');
    this._mount = this.querySelector('[data-sgm-mount]');
    this._loaded = false;

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-sgm-open]')) {
        e.preventDefault();
        this.open();
      } else if (e.target.closest('[data-sgm-close]') || e.target === this._overlay) {
        e.preventDefault();
        this.close();
      }
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (e.target.closest('[data-sgm-open]')) {
        e.preventDefault();
        this.open();
      } else if (e.target.closest('[data-sgm-close]')) {
        e.preventDefault();
        this.close();
      }
    });
  }

  open() {
    this._overlay.hidden = false;
    if (!this._loaded) this.load();
  }

  close() {
    this._overlay.hidden = true;
  }

  async load() {
    this._loaded = true;
    const url = this.dataset.fetchUrl;
    if (!url) return this.fail();
    try {
      const res = await fetch(url);
      if (!res.ok) return this.fail();
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('.vrt-sizeguide');
      if (!fresh) return this.fail();
      this._mount.appendChild(fresh);
      this._status.hidden = true;
    } catch (e) {
      this.fail();
    }
  }

  fail() {
    this._status.textContent = 'Size guide coming soon.';
  }
}

if (!customElements.get('vrt-sizeguide-modal')) {
  customElements.define('vrt-sizeguide-modal', VrtSizeguideModal);
}
